
import { defineComponent } from 'vue';
import { PersianDate } from '@/Utils/persian-date';
import { UserIdentifyDocumentModel } from '@/interfaces/users/user-identify-document.model';
import CheckUserIdentifyComponent from "@/components/appComponents/CheckUserIdentify.vue";
import store from '@/store';

export default defineComponent({
    name: "UserIdentifyTableComponent",

    props: ["users"],

    components: { CheckUserIdentifyComponent },

    data(): any {
        return {
            document: {},
            persianDateConverter: new PersianDate(),
            tableHeaders: [
                "نام و نام خانوادگی",
                "کد ملی",
                "تاریخ تولد",
                "تاریخ ارسال",
                "گزینه ها"
            ],
            defaultImage: require("@/assets/icons/document.svg"),
            showCheckUserDocument: false
        }
    },

    methods: {
        persianDate(utcDateTime: string): string {
            return this.persianDateConverter.convert(utcDateTime, true);
        },

        closeCheckUserIdentify() {
            this.showCheckUserDocument = false;
        },

        FormatPersianAmount(amount: number | string): string {
            // Convert to number if it's a string
            const num = typeof amount === 'string' ? parseFloat(amount) : amount;

            if (isNaN(num)) {
                return "مبلغ نا معتبر"; // Or handle the error as you prefer
            }

            const parts = num.toString().split(".");
            const integerPart = parts[0];
            const fractionalPart = parts[1] || '';

            // Apply thousands separator to the integer part
            const formattedIntegerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

            // Combine integer and fractional parts
            const formattedAmount = fractionalPart ? `${formattedIntegerPart}.${fractionalPart}` : formattedIntegerPart;

            return formattedAmount;
        },

        handleOption(item: UserIdentifyDocumentModel) {
            this.showCheckUserDocument = true;
            this.document = item;
        },

        handleSubmitSendUserIdentify(data: {
            userId: string,
            reject: boolean,
            message: string,
        }): void {

            if (!data.reject) {
                store.dispatch("panel/sendAccepctUserIdentifyRequest", data.userId).then(() => {
                    this.showCheckUserDocument = false;
                })
            } else {
                const rejectData = {
                    userId: data.userId,
                    message: data.message
                }
                
                store.dispatch("panel/sendRejectUserIdentifyRequest", rejectData).then(() => {
                    this.showCheckUserDocument = false;
                })
            }
        }
    },
})
